import { walletApi } from "@/betby/api/services";
import { useAuthStore } from "@/betby/store/authStore";
import { useNavStore, type CurrencyMode } from "@/betby/store/navStore";
import LogUtil from "@/betby/utils/LogUtil";
import { sendUrlChangeMessage } from "@/betby/models/host/unityMessageService";
import type { BTRendererInstance } from "@/betby/types/betby";

export interface UnityMessageRuntime {
  refreshWallet?: () => Promise<void>;
  syncMoneyType?: (currencyType: CurrencyMode) => Promise<void> | void;
  navigate?: (url: string) => void;
}

let activeUnityMessageRuntime: UnityMessageRuntime | null = null;
let betbyInstance: BTRendererInstance | null = null;

export function setBetbyInstance(instance: BTRendererInstance | null): void {
  betbyInstance = instance;
}

export function registerUnityMessageRuntime(
  runtime: UnityMessageRuntime | null,
): void {
  activeUnityMessageRuntime = runtime;
}

export function getUnityMessageRuntime(): UnityMessageRuntime | null {
  return activeUnityMessageRuntime;
}

export function createDefaultUnityMessageRuntime(): UnityMessageRuntime {
  return {
    refreshWallet: async () => {
      try {
        const res = await walletApi.getBalance();
        if (res.code === 200 && res.data) {
          const { setUserInfo, userInfo } = useAuthStore.getState();
          if (userInfo) {
            setUserInfo({
              ...userInfo,
              wallet_info_usd: res.data.wallet_info_usd,
            });
          }
          LogUtil.info("[UnityMessageRuntime] 余额刷新成功");
        }
      } catch (error) {
        LogUtil.error("[UnityMessageRuntime] 余额刷新失败", error);
      }
    },
    syncMoneyType: (currencyType) => {
      const { currentMode, initCurrency } = useNavStore.getState();
      if (currentMode !== currencyType) {
        initCurrency(currencyType);
      }

      const { setUserInfo, userInfo } = useAuthStore.getState();
      if (userInfo) {
        setUserInfo({
          ...userInfo,
          currency_type: currencyType,
        });
      }
    },
    navigate: (url: string) => {
      LogUtil.info("[UnityMessageRuntime] 执行导航:", url);
      if (betbyInstance) {
        betbyInstance.updateOptions({ url });
        sendUrlChangeMessage(url);
      } else {
        LogUtil.warn("[UnityMessageRuntime] Betby 实例未注册，忽略导航请求");
      }
    },
  };
}
